import { randomInt } from "@llmgateway/shared/random";

export const heroSuggestionGroups = {
	Create: [
		"Write a Python script to analyze CSV data and create visualizations",
		"Create a compelling elevator pitch for a sustainable fashion startup",
		"Explain quantum computing like I'm 12 years old",
		"Design a 7-day workout plan for busy professionals",
		"Write a short mystery story in exactly 100 words",
		"Draft a launch announcement for a new productivity app",
		"Create a weekly meal plan for a vegetarian family",
		"Write a persuasive email asking for a project extension",
		"Design a morning routine for better focus and energy",
		"Create a checklist for moving into a new apartment",
		"Write a heartfelt birthday message for a close friend",
		"Draft a social media calendar for a local bakery",
		"Create a budget plan for saving for a vacation",
		"Write a product description for noise-canceling headphones",
		"Design a 30-day habit-building challenge",
		"Create a study schedule for final exams",
		"Write a professional bio for a conference speaker",
		"Draft a customer feedback survey for a SaaS product",
		"Create a packing list for a two-week Europe trip",
		"Write a bedtime story about a curious astronaut",
		"Design a beginner-friendly home workout routine",
		"Create interview questions for a product manager role",
		"Write a fundraising pitch for an animal shelter",
		"Draft a newsletter intro for a design studio",
		"Create a roadmap for learning Spanish in six months",
		"Write a mission statement for a climate nonprofit",
		"Design a themed dinner party menu",
		"Create a resume summary for a software engineer",
		"Write a thank-you note after a job interview",
		"Draft a script for a two-minute explainer video",
		"Create a content plan for a fitness coach",
		"Write a poem about rainy city streets",
		"Design a simple onboarding flow for a mobile app",
		"Create a list of icebreakers for a remote team meeting",
		"Write a grant proposal summary for a community garden",
		"Draft a polite cancellation email for a subscription",
		"Create a lesson plan about renewable energy",
		"Write a brand voice guide for a coffee shop",
		"Design a 7-day self-care plan",
		"Create a launch checklist for an online course",
		"Write a speech for a graduation ceremony",
		"Draft a one-page business plan for a pet grooming service",
		"Create a troubleshooting guide for home Wi-Fi issues",
		"Write a recipe for a quick weeknight pasta dinner",
		"Design a personal finance tracker layout",
		"Create a list of podcast episode ideas about startups",
		"Write a friendly reminder message for an upcoming event",
		"Draft a cover letter for a marketing role",
		"Create a travel itinerary for three days in Kyoto",
		"Write a short mystery story set in a museum",
	],
	Explore: [
		"What are trending AI research topics right now?",
		"Summarize the latest news about TypeScript",
		"Find interesting datasets for a side project",
		"Suggest tech blogs to follow for frontend performance",
		"Explain the main arguments for and against remote work",
		"Compare different approaches to personal knowledge management",
		"What should I know before learning machine learning?",
		"Explore the history of open-source software",
		"Explain how electric vehicles affect the power grid",
		"Compare popular note-taking systems for students",
		"What are the tradeoffs between SQL and NoSQL databases?",
		"Explain why some startups choose freemium pricing",
		"What are the biggest challenges in space exploration?",
		"Explore how recommendation algorithms shape media habits",
		"Compare different ways to learn a new language",
		"What are the benefits and risks of biometric authentication?",
		"Explain how carbon markets work",
		"Explore the future of wearable health technology",
		"Compare monoliths, microservices, and modular monoliths",
		"What makes a city friendly for cyclists?",
		"Explain the basics of behavioral economics",
		"Explore how music streaming changed the music industry",
		"Compare different productivity methods for creative work",
		"What are the ethical issues around facial recognition?",
		"Explain how vaccines are developed and tested",
		"Explore the history of the internet in five milestones",
		"Compare different renewable energy sources",
		"What should founders know about product-market fit?",
		"Explain how inflation affects household budgets",
		"Explore why some games become cultural phenomena",
		"Compare the strengths of Python, Go, and Rust",
		"What are the signs of a healthy engineering culture?",
		"Explain how supply chains recover from disruption",
		"Explore how cities can prepare for extreme heat",
		"Compare different approaches to digital privacy",
		"What makes a scientific study trustworthy?",
		"Explain how venture capital funding rounds work",
		"Explore the psychology of habit formation",
		"Compare traditional search engines and AI answer engines",
		"What are promising uses for augmented reality?",
		"Explain how public transit planning works",
		"Explore the impact of automation on office work",
		"Compare popular project management frameworks",
		"What are the basics of climate adaptation?",
		"Explain how encryption protects messages",
		"Explore why certain brands build strong communities",
		"Compare different ways to evaluate model quality",
		"What are common causes of software project delays?",
		"Explain how nutrition labels should be read",
		"Explore how online communities set and enforce norms",
	],
	Code: [
		"Refactor this React component for readability",
		"Write unit tests for a Node.js service",
		"Explain how to debounce an input in React",
		"Show an example of a Zod schema with refinement",
		"Debug this React component and suggest performance improvements",
		"Analyze the pros and cons of different programming languages",
		"Write a TypeScript utility to group objects by key",
		"Create a Hono route with Zod request validation",
		"Explain how React Server Components work",
		"Write a SQL query to find duplicate email addresses",
		"Design a REST API for a simple task manager",
		"Convert this JavaScript function to strict TypeScript",
		"Explain how to avoid prop drilling in React",
		"Write a Vitest test for an async function",
		"Create a reusable pagination helper",
		"Explain the difference between promises and async/await",
		"Write a custom React hook for local storage",
		"Design a database schema for event registrations",
		"Review this function for edge cases and bugs",
		"Explain how indexes improve database query speed",
		"Write a TypeScript type guard for API responses",
		"Create a small CLI script that renames files",
		"Explain how CORS works in a web application",
		"Write a migration-safe plan for renaming a database column",
		"Create a TanStack Query hook for loading projects",
		"Explain how to structure errors in an API",
		"Write a utility to validate environment variables",
		"Design a rate limiter for an HTTP endpoint",
		"Explain when to use useMemo in React",
		"Write a function to parse and format currency values",
		"Create a type-safe configuration object",
		"Explain how WebSockets differ from server-sent events",
		"Write a test plan for a login flow",
		"Create a small middleware for request logging",
		"Explain how optimistic updates work",
		"Write a function to sort semantic version strings",
		"Design an authorization model for teams and projects",
		"Explain how to diagnose a memory leak in Node.js",
		"Write a reusable form validation schema",
		"Create a simple caching layer with expiration",
		"Explain the difference between unit and integration tests",
		"Write a utility to retry failed network requests",
		"Design a file upload flow with progress reporting",
		"Explain how to prevent SQL injection",
		"Write a React component with accessible keyboard navigation",
		"Create a script to summarize JSON log files",
		"Explain how package lockfiles prevent dependency drift",
		"Write a type-safe event emitter in TypeScript",
		"Design a feature flag system for a frontend app",
		"Explain how to profile slow rendering in React",
	],
	"Image gen": [
		"Generate an image of a cyberpunk city at night",
		"Create a serene mountain landscape at sunrise",
		"Design a futuristic robot assistant",
		"Generate a cozy reading nook with warm afternoon light",
		"Create a watercolor illustration of a seaside village",
		"Design a sleek electric motorcycle concept",
		"Generate a fantasy library hidden inside a giant tree",
		"Create a minimalist poster for a jazz festival",
		"Design a friendly mascot for a meal planning app",
		"Generate a cinematic shot of astronauts on Mars",
		"Create a product photo of a premium ceramic coffee mug",
		"Design a retro travel poster for Lisbon",
		"Generate an isometric workspace for a game developer",
		"Create a children's book illustration of a moonlit garden",
		"Design a modern logo concept for a climate startup",
		"Generate a high-fashion editorial portrait in a studio",
		"Create a botanical pattern for sustainable packaging",
		"Design a concept art scene for an underwater city",
		"Generate a realistic kitchen with Scandinavian design",
		"Create a vibrant album cover for an indie pop band",
		"Design a sci-fi control room with holographic displays",
		"Generate a macro photo of dew on a red leaf",
		"Create a playful sticker pack for a productivity app",
		"Design a luxury hotel lobby with art deco details",
		"Generate a dramatic storm over a desert highway",
		"Create a pixel art village during a winter festival",
		"Design a packaging concept for herbal tea",
		"Generate a fantasy map of an island kingdom",
		"Create a realistic portrait of a chef in a busy kitchen",
		"Design a futuristic sneaker in a studio product shot",
		"Generate a peaceful Japanese courtyard after rain",
		"Create a movie poster for a space mystery thriller",
		"Design a colorful mural for a community center",
		"Generate a 3D render of a smart home device",
		"Create a fashion lookbook image with bold geometric styling",
		"Design a cozy cabin interior during a snowstorm",
		"Generate a surreal dreamscape with floating staircases",
		"Create a food photography shot of handmade ramen",
		"Design a character portrait for a cyberpunk detective",
		"Generate a realistic greenhouse full of tropical plants",
		"Create a clean app store hero image for a meditation app",
		"Design a stained glass window inspired by ocean waves",
		"Generate a vintage camera on a wooden desk",
		"Create a fantasy creature concept with iridescent wings",
		"Design a modern exhibition booth for an AI conference",
		"Generate a nighttime street market with neon signs",
		"Create a claymation-style scene of a tiny bakery",
		"Design a book cover for a historical adventure novel",
		"Generate a realistic sports car on a mountain road",
		"Create a dreamy cloud city at golden hour",
	],
} as const;

export type HeroSuggestionGroup = keyof typeof heroSuggestionGroups;

export const videoStudioSuggestions = [
	"A cinematic drone shot flying through a neon-lit futuristic city at night",
	"A serene timelapse of clouds moving over mountain peaks at sunset",
	"A slow-motion shot of ocean waves crashing on a rocky coastline",
	"A magical forest with glowing fireflies and swirling mist",
	"An astronaut floating in space with Earth visible in the background",
	"A bustling Tokyo street scene in the rain with neon reflections",
	"A timelapse of a city waking up from night to morning",
	"A cozy coffee shop interior with rain on the windows",
	"A surfer riding a massive wave at golden hour",
	"A field of wildflowers swaying in the wind under a dramatic sky",
	"A vintage steam train passing through snowy mountains",
	"An aerial view of a winding river through an autumn forest",
	"A bioluminescent beach at night with glowing waves",
	"A colorful marketplace in Marrakech with vibrant crowds",
	"Northern lights dancing over a frozen lake",
	"A chef preparing sushi in a high-end Japanese restaurant",
	"A flock of birds forming patterns against a sunset sky",
	"A lighthouse standing firm against crashing storm waves",
	"A supercell thunderstorm forming over open plains",
	"A timelapse of flowers blooming in a sunlit garden",
	"An underwater shark gliding through a coral reef",
	"A motorcycle ride through winding mountain roads",
	"A cozy cabin fireplace with snow falling softly outside",
	"A close-up of raindrops landing on a colorful autumn leaf",
	"A rocket launching at dawn with dramatic golden light",
	"A waterfall cascading into a lush tropical jungle pool",
	"A nighttime carnival with a ferris wheel glowing in motion",
	"Two people sharing an umbrella on a rainy Paris street",
	"A wolf running through a snow-covered pine forest",
	"A hot air balloon drifting over the Cappadocia valley at sunrise",
] as const;

export const canvasSuggestions = [
	"A pricing page with three tiers and a highlighted popular plan",
	"A SaaS analytics dashboard with stat cards and a recent activity table",
	"A login form with email, password, and social sign-in buttons",
	"A landing page hero with a headline, subtitle, and two call-to-action buttons",
	"A user profile card with avatar, bio, and follow button",
	"A checkout summary with line items, totals, and a pay button",
	"A kanban board with three columns of task cards",
	"A settings page with grouped toggles and a save button",
	"A testimonial section with three customer quote cards",
	"An onboarding checklist with a progress bar and completed steps",
	"A newsletter signup section with an input and subscribe button",
	"A FAQ section with expandable questions",
	"A team page with a grid of member cards",
	"A product detail layout with gallery, description, and buy button",
	"A job board listing with filters and job cards",
	"An invoice template with a company header and itemized table",
	"A contact form with name, email, subject, and message fields",
	"A weather widget showing current conditions and a 5-day forecast",
	"A blog post layout with title, author byline, and article body",
	"A feature comparison table for two products",
] as const;

export const audioStudioSuggestions = [
	"Welcome to the Lounge — every frontier model, one membership.",
	"Thanks for calling. All of our agents are currently busy, but your call is important to us.",
	"Chapter one. The storm rolled in just after midnight, and the old lighthouse keeper knew the night would be long.",
	"Breaking news: scientists have discovered a new species of deep-sea creature off the coast of Japan.",
	"Take a deep breath in... and slowly release. Let the tension melt away from your shoulders.",
	"In a world where artificial intelligence writes the headlines, one developer dares to read the documentation.",
	"Your order has shipped! Expect delivery within three to five business days.",
	"Good evening, passengers. We are now beginning our descent into Lisbon, where the local time is 7:45 PM.",
	"Once upon a time, in a village nestled between two mountains, there lived a clockmaker who could repair anything but time itself.",
	"Today's forecast calls for clear skies, a gentle breeze, and a high of 24 degrees.",
	"Attention shoppers: the store will be closing in fifteen minutes. Please bring your final purchases to the register.",
	"And the winner of this year's award for best original soundtrack goes to...",
	"Step right up, ladies and gentlemen, and witness the most astonishing spectacle of the century!",
	"This is your captain speaking. We've reached our cruising altitude of 35,000 feet.",
	"The quick brown fox jumps over the lazy dog, while the curious cat watches from the windowsill.",
	"Hello and welcome back to the podcast. Today we're diving into the history of the synthesizer.",
	"Please leave your message after the tone, and we'll get back to you as soon as possible.",
	"Five, four, three, two, one — liftoff! We have liftoff of the morning research mission.",
	"Remember: a journey of a thousand miles begins with a single step.",
	"It was the best of times, it was the worst of times, it was the age of wisdom, it was the age of foolishness.",
] as const;

export function sampleSuggestions(
	items: readonly string[],
	count: number,
): readonly string[] {
	const shuffled = [...items];

	for (let i = shuffled.length - 1; i > 0; i--) {
		const j = randomInt(0, i + 1);
		const current = shuffled[i]!;
		shuffled[i] = shuffled[j]!;
		shuffled[j] = current;
	}

	return shuffled.slice(0, count);
}
